import { render, staticRenderFns } from "./tabs-body.vue?vue&type=template&id=c5d12d7a&"
import script from "./tabs-body.vue?vue&type=script&lang=js&"
export * from "./tabs-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports